module.exports = {
    /**
     * 扫描二维码并返回结果<br />
     * 对应native接口：scanQRCode
     * @method hysdk.scanQRCode
     * @category Scan
     * @example ./scanQRCode.js[1-12]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    scanQRCode: {
        hy: {
            key: 'scanQRCode'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    result: ret.resultStr
                };
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/scan.js
// module id = 15
// module chunks = 0 2 4